<template>
  <client-only>
    <div
      :class="popoverClass"
      @mouseover="handlerMouseover"
      @mouseout="handlerMouseout"
    >
      <template>
        <img
          class="icon-question"
          @click.stop="handleOpen"
          v-lazy="require(`@/assets/images/detail/goc-h5.png`)"
          alt="logo"
        />
      </template>

      <div @click.stop :class="popoverCls">
        <!-- hack 移出的hack的隔层 -->
        <div class="interlayer" />
        <div
          class="popover-arrow"
          :style="{ borderBottomColor: bgColor }"
        ></div>
        <div
          @mouseover="handlerMouseover"
          class="popovers"
          ref="popoverRef"
          :style="{ backgroundColor: bgColor }"
        >
          <div class="popovers-pad">
            <img class="tips-img" v-lazy="tipsImg" alt="logo" />
          </div>
        </div>
      </div>
    </div>
  </client-only>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { inputTips } from '@page_detail/firebase'
  export default {
    mixins: [styleConfiguration],
    props: {
      tipsImages: {
        type: String,
        default: '',
      },
      direction: {
        type: String,
        default: 'down', //down\up
      },
    },
    components: {},
    data() {
      return {
        isOpen: false,
      }
    },
    watch: {
      isOpen(newVal) {
        this['detail/setIsTipsOpen'](newVal)
        if (!newVal) return
        inputTips(this.gameName)
      },
    },
    computed: {
      ...mapState(['isDesktop', 'gameName', 'isMobile', 'region']),
      ...mapGetters(['isNew']),
      iconSize() {
        if (this.isDesktop) return 18
        return 36
      },
      popoverCls() {
        const defaults = ['popover-arrow-content']
        const _direction = this.direction === 'up' ? 'revolve' : ''
        return defaults.concat(_direction)
      },
      bgColor() {
        if (this.$__GAME__) {
          return this.skuBackColor.backgroundColor
        }
        return ''
      },
      iconColor() {
        if (this.$route.name === 'Detail2') {
          return hexToRgba(this.mFontColor.color, 0.5)
        }
        return '#999'
      },
      popoverClass() {
        const defaultClass = ['popover-content']
        const resClass = this.isDesktop
          ? `${defaultClass[0]}-desktop`
          : `${defaultClass[0]}-mobile`

        const custClass = this.isOpen ? 'show-content' : ''

        return defaultClass.concat(resClass, custClass)
      },
      tipsImg() {
        return this.tipsImages ? this.tipsImages : ''
      },
      tipsIcon() {
        return this.isNew
          ? require(`@/assets/images/detail/common/tips-for-dark.png`)
          : require(`@/assets/images/detail/common/tips.png`)
      },
    },
    mounted() {
      this.handlerDocumentClick(true)
    },
    destroyed() {
      this.handlerDocumentClick(false)
    },

    methods: {
      ...mapMutations(['detail/setIsTipsOpen']),
      // 点击空白处关闭
      handlerDocumentClick(isBind = true) {
        if (isBind) {
          document.addEventListener('click', this.hidePanel, false)
          return
        }
        document.removeEventListener('click', this.hidePanel, false)
      },
      hidePanel() {
        this.isOpen = false
      },
      getComputedOffset() {
        const popoverRef = this.$refs['popoverRef'] || null
        if (!popoverRef) {
          return {
            left: 0,
            right: 0,
            popoverRef,
          }
        }

        const { left, right } = popoverRef.getBoundingClientRect()
        const clientWidth = document.body.clientWidth
        return {
          left: Math.ceil(left),
          right: clientWidth - Math.ceil(right),
          popoverRef,
        }
      },

      setDOMOffset() {
        const { left, right, popoverRef } = this.getComputedOffset()

        if (!popoverRef) return

        if (this.direction === 'down') {
          if (left <= 10) {
            popoverRef.style.left = `${Math.abs(left) + 20}px`
          }

          if (right <= 10) {
            popoverRef.style.left = `${right - 10}px`
          }
        }

        if (this.direction === 'up') {
          if (left <= 10) {
            popoverRef.style.left = `${left - 5}px`
          }
          if (right <= 10) {
            popoverRef.style.left = `${Math.abs(right) + 10}px`
          }
        }
      },

      handleOpen() {
        this.setDOMOffset()
        this.isOpen = true
      },

      handlerMouseover() {
        if (this.isMobile) return
        this.isOpen = true
      },
      handlerMouseout() {
        if (this.isMobile) return
        this.isOpen = false
      },
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
